import { TenantReducer } from "./views/Tenant/ducks/TenantReducer.js";
import { studioWorkspaceSelectionReducer } from "./views/Tenant/WorkspaceSelector/StudioWorkspaceSelector.ducks.js";
const tenantReducers = {
  tenantReducer: TenantReducer,
  workspaceSelector: studioWorkspaceSelectionReducer
};
export {
  tenantReducers as default,
  tenantReducers
};
//# sourceMappingURL=reducers.js.map
